<template>
  <div id="app" class="min-h-screen w-full">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="postcss" scoped>
</style>
